import { keyframes, style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { RightContainerPayloadType } from './RightContainer';
import { isNil } from 'lodash';

export function rightContainer(payloadType: RightContainerPayloadType | undefined) {
  const width = payloadType === RightContainerPayloadType.Agent ? '38rem' : '25rem';

  const openPos = { left: `calc(100% - ${width})`, display: 'block' };
  const closedPos = { left: '101%', display: 'none' };

  const slideIn = keyframes({
    $debugName: 'slideIn',
    from: closedPos,
    to: openPos,
  });

  const slideOut = keyframes({
    $debugName: 'slideOut',
    from: openPos,
    to: closedPos,
  });

  let options: NestedCSSProperties = {
    $debugName: 'rightContainer',
    position: 'absolute',
    right: 0,
    zIndex: 103,
    backgroundColor: 'white',
    height: '100%',
    overflow: 'auto',
    borderLeft: '3px solid #ddd',
    width: width,
    animationDuration: '.4s',
  };

  if (isNil(payloadType)) {
    // no animation, initial component load
    options = {
      ...options,
      ...closedPos,
    };
  } else if (payloadType === RightContainerPayloadType.Collapsing) {
    // animate closed
    options = {
      ...options,
      ...closedPos,
      animationName: slideOut,
    };
  } else {
    // animate open
    options = {
      ...options,
      ...openPos,
      animationName: slideIn,
    };
  }

  return style(options);
}

const stylePane = style({
  $debugName: 'stylePane',
  height: '100%',
  overflow: 'auto',
});

const toggleStateIcon = style({
  $debugName: 'togglePane',
  marginTop: `calc(50vh - 16px)`,
});

const rightContainerCloseIcon = style({
  $debugName: 'rightContainerCloseIcon',
  marginRight: 10,
  $nest: {
    i: {
      cursor: 'pointer',
    },
  },
});

function styleHeaderSpacer(isStyleInfo: boolean) {
  return style({
    height: isStyleInfo ? '85px' : '50px',
  });
}

function styleHeaderContainer(isStyleInfo: boolean, payloadType: RightContainerPayloadType | undefined) {
  const width = payloadType === RightContainerPayloadType.Agent ? '36.9rem' : '23.9rem';
  return style({
    $debugName: 'rightContainerActionsContainer',
    width: width,
    position: 'fixed',
    display: 'flex',
    height: isStyleInfo ? 'auto' : '50px',
    justifyContent: isStyleInfo ? 'space-between' : 'flex-end',
    background: '#ffffff',
    paddingLeft: '1.1rem',
    paddingTop: '20px',
    zIndex: isStyleInfo ? 'initial' : 1,
  });
}

const headerText = style({
  fontWeight: 'bold',
  $nest: {
    '& .title': {
      fontSize: '20px',
      wordBreak: 'break-all',
    },
    '& .description': {
      fontSize: '12px',
      wordBreak: 'break-all',
    },
  },
});

const headerActions = style({
  display: 'flex',
  alignItems: 'baseline',
});

export default {
  styleHeaderContainer,
  styleHeaderSpacer,
  rightContainer,
  stylePane,
  toggleStateIcon,
  rightContainerCloseIcon,
  headerText,
  headerActions,
};
